import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPageUdin from "./LandingPageUdin/Pages";
import LoginUser from "./LandingPageUdin/Pages/authUser";
import Login from "./LandingPageUdin/Pages/auth/login";
import News from "./LandingPageUdin/Pages/dashboard/pejabat/pejabat";
import NewsDetail from "./LandingPageUdin/Pages/dashboard/pejabat/detail-pejabat";
import RouteGuard from "./utils/RouteGuard";
import DashboardLayout from "./LandingPageUdin/Pages/dashboard/page-dashboard";
import TambahNews from "./LandingPageUdin/Pages/dashboard/pejabat/tambah-pejabat";
import TambahKategori from "./LandingPageUdin/Pages/dashboard/pejabat/tambahkategori";
import PageUtama from "./LandingPageUdin/Pages/pageUtama/pageUtama";
import DetailPageUtama from "./LandingPageUdin/Pages/pageUtama/detailPageUtama";
import Register from "./LandingPageUdin/Pages/authUser/regis";
import RegisterStaff from "./LandingPageUdin/Pages/authUser/regisStaff";
import DetailLogo from "./LandingPageUdin/Pages/DataLogo/detailLogo";
import Aspirasi from "./LandingPageUdin/Pages/dashboard/aspirasi/aspirasi";
import DetailAspirasi from "./LandingPageUdin/Pages/dashboard/aspirasi/detail-aspirasi";
import AdminStafAktifasi from "./LandingPageUdin/Pages/dashboard/aktivasiAkun/aktivasi";
import AdminStafDetail from "./LandingPageUdin/Pages/dashboard/aktivasiAkun/detailaktivasi";
import EntryBio from "./LandingPageUdin/Pages/dashboard/pejabat/entrydatapejabat/entryBio";
import EntryLhkpn from "./LandingPageUdin/Pages/dashboard/pejabat/entrydatapejabat/entryLhkpn";
import EntryKinerja from "./LandingPageUdin/Pages/dashboard/pejabat/entrydatapejabat/entryKinerja";
import EntryQuisioner from "./LandingPageUdin/Pages/dashboard/pejabat/entrydatapejabat/entryQuisioner";
import Beranda from "./LandingPageUdin/Pages/dashboard/beranda/beranda";
import VoteKuisioner from "./LandingPageUdin/Pages/dashboard/vote/vote";
import DetailQuisioner from "./LandingPageUdin/Pages/dashboard/vote/detailVoteKuisioner";
import UserPengguna from "./LandingPageUdin/Pages/dashboard/beranda/TableDetailBeranda/userAll";
import AspirasiAllPejabat from "./LandingPageUdin/Pages/dashboard/beranda/TableDetailBeranda/aspirasiAllPejabat";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPageUdin />} />
        <Route path="/loginuser" element={<LoginUser />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/registerStaff" element={<RegisterStaff />} />
        <Route path="/pageutama" element={<PageUtama />} />
        <Route path="/detailPageUtama/:id" element={<DetailPageUtama />} />
        <Route path="/detail-bidang/:namaBidang" element={<DetailLogo />} />

        {/* ✅ Protected dashboard with layout and nested routes */}
        <Route
          path="/dashboard"
          element={
            <RouteGuard>
              <DashboardLayout />
            </RouteGuard>
          }>
          <Route path="/dashboard/beranda" element={<Beranda />} />
          <Route path="/dashboard/pejabat" element={<News />} />
          <Route path="/dashboard/presiden-detail/:id" element={<NewsDetail />} />
          <Route path="presiden/tambah" element={<TambahNews />} />
          <Route path="news/tambah-kategori" element={<TambahKategori />} />

          {/* ASPIRASI */}
          <Route path="/dashboard/aspirasi" element={<Aspirasi />} />
          <Route path="/dashboard/aspirasi/detail/:id" element={<DetailAspirasi />} />
          <Route path="/dashboard/beranda/aspirasiAll" element={<AspirasiAllPejabat />} />

          {/* VOTE KUISIONER */}
          <Route path="/dashboard/voteKuisioner" element={<VoteKuisioner />} />
          <Route path="/dashboard/voteKuisioner/detail/:id" element={<DetailQuisioner />} />

          {/* BIO LHKPN KINERJA */}
          <Route path="/dashboard/biografi/:id" element={<EntryBio />} />
          <Route path="/dashboard/lhkpn/:id" element={<EntryLhkpn />} />
          <Route path="/dashboard/kinerja/:id" element={<EntryKinerja />} />
          <Route path="/dashboard/qusioner/:id" element={<EntryQuisioner />} />

          {/* AKUN */}
          <Route path="/dashboard/pengguna" element={<UserPengguna />} />
          <Route path="/dashboard/akun" element={<AdminStafAktifasi />} />
          <Route path="/dashboard/akun/detail/:id" element={<AdminStafDetail />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
